<template>
  <!-- 顶部操作按钮 组件 author: zhangxiaofeng -->
  <div class="operation-buttons">
    <slot></slot>
    <div v-if="!isIE && buttons.indexOf('upload') > -1" class="upload__wrapper project_wrapper margin-right-10">
      <w-button type="primary">上传</w-button>
      <!-- 上传 下拉框 -->
      <div class="project__box">
        <!-- 人材机 上传 下来框 -->
        <template v-if="type === 'material'">
          <a href="javascript: void(0)" @click="chooseFile($event, 'excel')">
            <div class="uploader-pick w-120 icon-blue">
              <i class="r2-icon-excel"></i> 上传excel
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'PlatformFile')">
            <div class="uploader-pick w-120 icon-green">
              <i class="r2-icon-action_description"></i> 上传人材机数据
              <div class="input_wrapper">
                <input-file class="webuploader-element-invisible"
                            @change="uploadPlatformFile"
                            type="file" name="file">
                </input-file>
              </div>
            </div>
          </a>
        </template>
        <!-- 清单数据库、组价数据库 上传 下来框 -->
        <template v-else-if="type === 'inventory' || type === 'combination'">
          <a href="javascript: void(0)" @click="chooseFile($event, 'CloudFile')">
            <div class="uploader-pick w-120 icon-blue">
              <i class="r2-icon-file_cloud"></i> 上传云文件
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'LocalFile')">
            <div class="uploader-pick w-120 icon-orange">
              <i class="r2-icon-hardware_desktop_mac"></i> 上传本地文件
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="uploadLocalFile"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'PlatformFile')">
            <div class="uploader-pick w-120 icon-green">
              <i class="r2-icon-action_description"></i>
              上传{{type=='inventory' ? '清单' : (type=='combination' ? '组价' : '')}}数据
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="uploadPlatformFile"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
        </template>
        <template v-else>
          <a href="javascript: void(0)" @click="chooseFile($event, 'file')">
            <div class="uploader-pick icon-blue">
              <i class="r2-icon-action_description"></i> 上传文件
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="upload"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'folder')">
            <div class="uploader-pick icon-green">
              <i class="r2-icon-ile_folder"></i> 上传文件夹
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="upload"
                          type="file" name="file" multiple="multiple" webkitdirectory>
              </input-file>
            </div>
          </a>
        </template>
      </div>
    </div>
    <div v-else-if="isIE && (type === '') && buttons.indexOf('upload') > -1" class="upload__wrapper project_wrapper margin-right-10">
      <w-button class="margin-right-10" type="primary" @click="chooseFile($event, 'file')">
        上传
      </w-button>
    </div>
    <div v-else-if="buttons.indexOf('upload') > -1" class="upload__wrapper project_wrapper margin-right-10">
      <w-button class="margin-right-10" type="primary">上传</w-button>
      <!-- 上传 下拉框 -->
      <div class="project__box">
        <!-- 人材机 上传 下来框 -->
        <template v-if="type=='material'">
          <a href="javascript: void(0)" @click="chooseFile($event, 'excel')">
            <div class="uploader-pick w-120 icon-blue">
              <i class="r2-icon-excel"></i> 上传excel
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'PlatformFile')">
            <div class="uploader-pick w-120 icon-green">
              <i class="r2-icon-action_description"></i> 上传人材机数据
              <div class="input_wrapper">
                <input-file class="webuploader-element-invisible"
                            @change="uploadPlatformFile"
                            type="file" name="file">
                </input-file>
              </div>
            </div>
          </a>
        </template>
        <!-- 清单数据库、组价数据库 上传 下来框 -->
        <template v-else-if="type=='inventory' || type=='combination'">
          <a href="javascript: void(0)" @click="chooseFile($event, 'CloudFile')">
            <div class="uploader-pick w-120 icon-blue">
              <i class="r2-icon-file_cloud"></i> 上传云文件
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'LocalFile')">
            <div class="uploader-pick w-120 icon-orange">
              <i class="r2-icon-hardware_desktop_mac"></i> 上传本地文件
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="uploadLocalFile"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'PlatformFile')">
            <div class="uploader-pick w-120 icon-green">
              <i class="r2-icon-action_description"></i>
              上传{{type=='inventory' ? '清单' : (type=='combination' ? '组价' : '')}}数据
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="uploadPlatformFile"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
        </template>
        <template v-else>
          <a href="javascript: void(0)" @click="chooseFile($event, 'file')">
            <div class="uploader-pick icon-blue">
              <i class="r2-icon-action_description"></i> 上传文件
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="upload"
                          type="file" name="file" multiple="multiple">
              </input-file>
            </div>
          </a>
          <a href="javascript: void(0)" @click="chooseFile($event, 'folder')">
            <div class="uploader-pick icon-green">
              <i class="r2-icon-ile_folder"></i> 上传文件夹
            </div>
            <div class="input_wrapper">
              <input-file class="webuploader-element-invisible"
                          @change="upload"
                          type="file" name="file" multiple="multiple" webkitdirectory>
              </input-file>
            </div>
          </a>
        </template>
      </div>
    </div>
    <div v-if="buttons.indexOf('uploadBtn') > -1" class="upload__wrapper project_wrapper margin-right-10">
      <w-button type="primary" class="w-button_green file-upload-button"
                @click="chooseFile($event, 'PlatformFile', true)">
        <!--<i class="w-icon-shangchuan"></i>-->
        上传
        <!--<input-file class="webuploader-element-invisible input_wrapper"-->
                    <!--@change="uploadPlatformFile"-->
                    <!--type="file" name="file" multiple="multiple">-->
        <!--</input-file>-->
        <div class="input_wrapper">
          <input-file class="webuploader-element-invisible input_wrapper"
            @change="uploadPlatformFile"
            type="file" name="file" multiple="multiple">
          </input-file>
        </div>
      </w-button>
    </div>
    <template v-for="(btn, idx) in buttons">
      <w-button ghost size="small" v-if="btn === 'cancel'" :key="'top_button_' + idx" @click.native="clickFn(btn, $event)">取消多选</w-button>
      <template v-else-if="btn === 'export'">
        <!-- 电子档案室 无权限导出的 导出按钮 -->
        <el-tooltip  v-if="disabledButton && disabledButton[idx]" :content="tipContent && tipContent[idx] || '提示'" placement="bottom">
          <w-button type="minor"
                    style="margin-right: 10px;"
                    :class="['project_wrapper', btn, disabledButton[idx] ? 'export-button--disabled' : '']"
                    :key="'top_button_' + idx" @click.native="clickFn(btn, $event)">
            导出
          </w-button>
        </el-tooltip>
        <!-- 其他导出按钮 -->
        <div  v-else class="switch-wrapper">
          <w-button type="minor"
                    :class="['project_wrapper', btn]"
                    :key="'top_button_' + idx" @click.native="clickFn(btn, $event)">
            导出
          </w-button>
          <!-- 人材机 导出下来选项 下面这个盒子不要放到w-button里面不然IE 下 点击 没反应 -->
          <div  v-if="type=='material'" class="export-box">
            <a href="javascript: void(0)" @click="clickFn('exportExcel', $event)">
              <div class="uploader-pick icon-blue" style="letter-spacing: normal">
                <i class="r2-icon-excel"></i> excel导出
              </div>
            </a>
            <a href="javascript: void(0)" @click="clickFn('export', $event)">
              <div class="uploader-pick icon-green" style="letter-spacing: normal">
                <i class="r2-icon-action_description"></i> 平台接口导出
              </div>
            </a>
          </div>
        </div>
      </template>

      <div class="switch-wrapper" v-else-if="btn !== 'upload' && btn !== 'uploadBtn'">
        <w-button :class="['project_wrapper', btn]"
                  :key="'top_button_' + idx" @click.native="clickFn(btn, $event)"
                  :type="['delete', 'cancelGroupBest'].includes(btn)  ? 'warning' : 'default'">

          <template v-if="btn === 'openGCCP6'">
            新建计价工程
          </template>

          <template v-if="btn === 'addProject'">
            创建项目
          </template>

          <template v-if="btn === 'unfoldTo'">
            <i class="w-icon-zhankaidao"></i>展开到
          </template>

          <template v-if="btn === 'signGroupBest'">
            <i class="w-icon-dianzan"></i> 设为最佳组价
          </template>

          <template v-if="btn === 'cancelGroupBest'">
            <i class="w-icon-quxiaozuijiazujia"></i> 取消最佳组价
          </template>

          <template v-if="btn === 'restore'">
            <!--<i class="w-icon-huanyuan"></i> -->
            还原
          </template>

          <template v-if="btn === 'deleteThoroughly'">
            <!--<i class="r2-icon-action_delete_outline"></i> -->
            彻底删除
          </template>

          <template v-if="btn === 'clear'">
            <!--<i class="r2-icon-action_delete_outline"></i> -->
            清空回收站
          </template>

          <template v-if="btn === 'copyToCompanySpace'">
            <!-- 员工 才显示 复制到共享空间 按钮 -->
            <!--<i class="w-icon-fuzhidaoqiyekongjian"></i> -->
            {{origin === 'database' ? '复制到电子档案室' : '复制到共享空间'}}
          </template>

          <template v-if="btn === 'move'">
            移动到
          </template>

          <template v-if="btn === 'inspectBatch'">
            通过审核
          </template>

          <template v-if="btn === 'delete'">
            删除
          </template>

          <template v-if="btn === 'download'">
            下载
          </template>

          <template v-if="btn === 'refresh'">
            刷新
          </template>

          <template v-if="btn === 'addFolder'">
            新建文件夹
          </template>

        </w-button>
        <!-- 展开到 下拉框 别把这个放在 w-button里面 否则 IE 下 点击无效 -->
        <div v-if="btn === 'unfoldTo'" class="project__box">
          <a href="javascript: void(0)" @click.stop="clickFn(btn, $event, 'BQ')">
            <div class="uploader-pick w-59">
              清单
            </div>
          </a>
          <a href="javascript: void(0)" @click.stop="clickFn(btn, $event, 'NORM')">
            <div class="uploader-pick w-59">
              定额
            </div>
          </a>
          <a href="javascript: void(0)" @click.stop="clickFn(btn, $event, 'RES')">
            <div class="uploader-pick w-59">
              人材机
            </div>
          </a>
        </div>
      </div>
    </template>


  </div>
</template>
<style lang="less" type="text/less" scoped>
  .color555 {
    color: #555 !important;
  }

  .operation-buttons {
    .upload__wrapper {
      /*margin-right: 10px;*/
      position: relative;
      z-index: 10;
    }

    .w-button {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    .project_wrapper, &.project_wrapper {
      display: inline-block;
      position: relative;
    }

    .ant-btn {
      border-radius: 4px;
      margin-right: 12px;

      &.opration-button-defult {
        border: 1px solid rgba(32, 121, 250, 1);
        color: #2079FA;
      }
    }

    .opration-button-danger {
      border: 1px solid rgba(224, 32, 32, 1);
      border-radius: 4px;
      color: #E02020;
      /*margin-right: 12px;*/
    }
  }


  .project__box {
    position: absolute;
    top: 31px;
    left: 0;
    background-color: #fff;
    /*border: 1px solid #ccc;*/
    padding: 8px 0;
    text-align: left;
    display: none;
    z-index: 10;
    /*z-index: -1;*/
    /*visibility: hidden;*/
    font-size: 12px;
    color: #555;
    white-space: nowrap;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .25);

    & > a {
      display: block;
      padding: 9px 16px;
      line-height: 26px;
      color: #555;
      text-align: left;
      position: relative;
      word-break: keep-all;
      width: auto;
      font-size: 14px;
      &:hover {
        background-color: rgba(243,244,247,1);
        text-decoration: none
      }
      .uploader-pick {
        position: relative;
        display: block;
        width: auto;
        height: 100%;
        cursor: pointer;
        overflow: hidden;
        &.icon-blue {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 16px;
            background:rgba(32,121,250,1);
            color: #ffffff;
          }
        }
        &.icon-orange {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 16px;
            background:rgba(248,149,2,1);
            color: #ffffff;
          }
        }
        &.icon-green {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 16px;
            background:rgba(23,217,158,1);
            color: #ffffff;
          }
        }

        &.w-59 {
          width: 59px;
        }

        &.w-100 {
          width: 100px;
        }

        &.w-120 {
          width: 120px;
        }

        [class*=" w-icon-"], [class^=w-icon-] {
          display: inline;
          font-size: 12px;
          position: relative;
          top: -1px;
          margin-right: 3px;
        }
      }

      .input_wrapper {
        position: absolute;
        top: 5px;
        left: 10px;
        width: 79px;
        height: 16px;
        overflow: hidden;
        bottom: auto;
        right: auto;

        input {
          position: absolute !important;
          clip: rect(1px, 1px, 1px, 1px);
        }

        label {
          opacity: 0;
          width: 100%;
          height: 100%;
          display: block;
          cursor: pointer;
          background: rgb(255, 255, 255);
        }
      }
    }
  }
  .export-box {
    position: absolute;
    top: 31px;
    left: 0;
    background-color: #fff;
    /*border: 1px solid #ccc;*/
    padding: 5px 0;
    text-align: left;
    /*z-index: -1;*/
    /*visibility: hidden;*/
    display: none;
    z-index: 10;
    /*line-height: 30px;*/
    font-size: 12px;
    color: #555;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .25);

    & > a {
      display: block;
      padding: 9px 16px;
      line-height: 26px;
      color: #555;
      text-align: left;
      position: relative;
      word-break: keep-all;
      width: auto;
      .uploader-pick {
        position: relative;
        display: block;
        width: auto;
        height: 100%;
        cursor: pointer;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        &.icon-blue {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            background:rgba(32,121,250,1);
            color: #ffffff;
          }
        }
        &.icon-orange {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            background:rgba(248,149,2,1);
            color: #ffffff;
          }
        }
        &.icon-green {
          [class*=" w-icon-"], [class^=w-icon-], [class*=" r2-icon-"], [class^=r2-icon-] {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            background:rgba(23,217,158,1);
            color: #ffffff;
          }
        }

        &.w-59 {
          width: 59px;
        }

        &.w-120 {
          width: 120px;
        }

        [class*=" w-icon-"], [class^=w-icon-] {
          width:26px;
          height:26px;
          display: inline-block;
          /*display: inline;*/
          font-size: 12px;
          position: relative;
          top: -1px;
          margin-right: 3px;
        }
      }

      .input_wrapper {
        position: absolute;
        top: 5px;
        left: 10px;
        width: 79px;
        height: 16px;
        overflow: hidden;
        bottom: auto;
        right: auto;

        input {
          position: absolute !important;
          clip: rect(1px, 1px, 1px, 1px);
        }

        label {
          opacity: 0;
          width: 100%;
          height: 100%;
          display: block;
          cursor: pointer;
          background: rgb(255, 255, 255);
        }
      }

      &:hover {
        background-color: rgba(243,244,247,1);
        text-decoration: none
      }
    }
  }

  .switch-wrapper, .project_wrapper{
    display: inline-block;
    position: relative;
    &:hover, &.show {
      .project__box {
        /*loading 动画遮罩层级为2000*/
        /*z-index: 2001;*/
        /*visibility: visible;*/
        display: block;
      }
      .export-box {
        display: block;
        /*visibility: visible;*/
        /*z-index: 2001;*/
      }
    }
  }
  .switch-wrapper{
    margin-right: 10px;
  }
  .file-upload-button {
    position: relative;

    .input_wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      opacity: 0;
    }
  }
</style>
<script>
/* eslint-disable no-new */

import InputFile from './InputFile'
import {getCookie} from '@/assets/utils/CommonUtil'
import {isIE} from '@/assets/utils'

export default {
  name: 'OperationButtons',
  props: {
    buttonList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: false,
      default: () => ''
    },
    origin: {
      type: String,
      default: ''
    },
    disabledButton: { // 禁用的按钮 索引 对象
      type: Object,
      default: () => {}
    },
    tipContent: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      user: {},
      isIE: isIE()
    }
  },
  computed: {
    buttons () {
      const list = []
      this.buttonList.forEach((item) => {
        if (item === 'copyToCompanySpace') {
          switch (this.pageType) {
            case 'databaseBasis': // 企业造价数据 没有 复制到电子档案室 操作
            case 'enterpriseShare': // 共享空间 没有 复制到共享空间 操作
              break
            default:
              if ([2, 3, 4].includes(this.role)) {
                list.push(item)
              }
          }
        } else if (item === 'inspectBatch') {
          // 批量审核
          if (this.pageType === 'databaseBasis') {
            list.push(item)
          }
        } else {
          list.push(item)
        }
      })
      return list
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
  },
  methods: {
    // 1. 上传 弹出选择文件/文件夹 选框
    chooseFile (e, type, isFocus = false) {
      const focus = () => {
        // 兼容IE MouseEvent
        (function (window) {
          try {
            new MouseEvent('test')
            return false
          } catch (e) {

          }
          var MouseEvent = function (eventType, params) {
            params = params || {bubbles: false, cancelable: false}
            var mouseEvent = document.createEvent('MouseEvent')
            mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            return mouseEvent
          }
          MouseEvent.prototype = Event.prototype
          window.MouseEvent = MouseEvent
        })(window)
        // console.log(e.target);
        if (e && e.target) {
          const evt = new MouseEvent('click', {
            bubbles: false,
            cancelable: true,
            view: window
          })
          const inputNodes = e.target.getElementsByTagName('input')
          // console.log(inputNodes);
          if (inputNodes && inputNodes[0]) {
            inputNodes[0].dispatchEvent(evt)
          }
        }
      }
      // console.log('-=-=');
      switch (type) {
        case 'CloudFile':
          this.$emit('uploadHandle', [], e, type)
          break
        case 'LocalFile':
          this.$emit('uploadHandle', [], e, type)
          break
        case 'PlatformFile':
          // console.log(this.type);
          if (this.type === 'material' || isFocus) {
            focus()
          }
          this.$emit('uploadHandle', [], e, type)
          break
        case 'excel':
          this.$emit('uploadHandle', [], e, type)
          break
        case 'file':
          this.$emit('uploadHandle', type)
          break
        case 'folder':
          this.$emit('uploadHandle', type)
          break
        default:
          focus()
      }
    },
    // 1.1 上传 选中的文件夹/文件
    upload (files, e) {
      this.$emit('uploadHandle', files, e)
    },
    // 1.2 上传 本地文件
    uploadLocalFile (files, e) {
      this.$emit('uploadHandle', files, e, 'LocalFile')
    },
    // 1.3 上传 平台文件
    uploadPlatformFile (files, e) {
      this.$emit('uploadHandle', files, e, 'Platform')
    },
    // 2. 其他按钮点击
    clickFn (type, e, value) {
      console.log(type)
      console.log(e)
      console.log(value)
      console.log(this.type)
      if (type === 'unfoldTo' && !value) return
      this.$emit('clickHandle', type, e, value || '')
    }
  },
  components: {
    InputFile
  }
}
</script>
